import styled from "@emotion/styled";

export const Details = styled("div")({
  marginBottom: 24,
  display: "flex",
  flexDirection: "column" as const,
  gap: 24,
});

export const OrderLink = styled("a")(() => ({
  cursor: "pointer !important",
}));

export const OrdersLabel = styled("span")(() => ({
  color: "#308CDB",
  fontFamily: "Manrope",
  fontSize: 14,
  fontWeight: 700,
  lineHeight: 1.5,
  marginBottom: 10,
}));

export const OrderWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column" as const,
  gap: 4,
}));

export const OrderRoot = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 24,

  "& > div:first-child": {
    position: "relative" as const,
    "&::after": {
      content: "''",
      position: "absolute" as const,
      height: 4,
      width: 4,
      backgroundColor: "#465869",
      borderRadius: "50%",
      top: "50%",
      right: "-10.7%",
      transform: "translate(-210%, -50%)",
    },
  },
}));

export const OrderReference = styled("span")(() => ({
  color: "#667085",
  fontSize: 14,
  fontFamily: "Manrope",
  fontWeight: 500,
  lineHeight: 1.5,
  paddingInlineEnd: 4,
  "& > a": {
    color: "#308CDB !important",
    cursor: "default",
  },
}));

export const OrderUploadDate = styled("span")(() => ({
  color: "#667085",
  fontFamily: "Manrope",
  fontSize: 14,
  fontWeight: 500,
  lineHeight: 1.5,
}));

export const EmptyValue = styled("span")(() => ({
  color: "#93A9BD",
  fontFamily: "Manrope",
  fontSize: 14,
  fontWeight: 500,
}));
